import clsx from "clsx";
import React from "react";
import { AnimatedGradientBorder, GlowCard } from "screens/Landing/components/shared";
import { gradientRowBgClass } from "screens/Dashboard/utils/classes";

type SectionHeaderProps = {
  title: string;
  desc?: string;
  sectionHeaderClasses?: string;
  titleClass?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  desc,
  sectionHeaderClasses = "",
  titleClass,
}) => {
  return (
    <AnimatedGradientBorder className="rounded-[1.94vw] max-lg:rounded-[6.45vw] w-full">
      <GlowCard
        className={clsx(
          "bg-[#111111] p-[0.9vw] max-lg:p-[3.2vw] !rounded-[1.94vw] max-lg:!rounded-[6.45vw] flex flex-col gap-[4vw] w-full",
          sectionHeaderClasses
        )}
      >
      <div className={clsx("w-full flex items-center justify-between p-[0.9vw] max-lg:px-[4.26vw] max-lg:py-[3.2vw] rounded-[1.11vw] max-lg:rounded-[3.2vw] before:!rounded-[1.11vw] max-lg:before:!rounded-[3.2vw]", gradientRowBgClass)}>
        <h2
          className={clsx(
            "text-[2.23vw] font-luxora-medium  max-lg:text-20m leading-[1.1] text-white ",
            titleClass
          )}
        >
          {title}
        </h2>
        {desc && (
          <p className="bg-[#1a1a1a] h-[3vw] max-lg:hidden px-6 flex items-center font-[400] text-[#665BFF] text-16 leading-[1.1] custom-shadow rounded-xl">
            {desc}
          </p>
        )}
      </div>
      {desc && (
        <p className="bg-[#1a1a1a] lg:hidden max-lg:px-[4vw] max-lg:py-[2.13vw] flex items-center font-[400] text-[#665BFF] max-lg:text-14m max-lg:leading-[110%] custom-shadow rounded-xl">
          {desc}
        </p>
      )}
      </GlowCard>
    </AnimatedGradientBorder>
  );
};

export default SectionHeader;
